export default __webpack_public_path__ + "static/media/dark_mail.4931e103.svg";